/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * NewStart Debt Relief Nonprofit API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminListAuditLogsParams,
  AdminStats,
  AuditLog,
  BadgeInfo,
  CheckoutResponse,
  ClaimAdminBody,
  CreateDonationCheckoutBody,
  CreatePoolBody,
  Debt,
  Donation,
  DonorImpact,
  HealthStatus,
  LeaderboardEntry,
  Payout,
  Pool,
  PoolListResponse,
  PoolStats,
  UpdateUserBody,
  UploadDebtBody,
  UserProfile,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current user profile
 */
export const getGetMeUrl = () => {
  return `/api/users/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserProfile> => {
  return customFetch<UserProfile>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/users/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<void>;

/**
 * @summary Get current user profile
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update current user profile
 */
export const getUpdateMeUrl = () => {
  return `/api/users/me`;
};

export const updateMe = async (
  updateUserBody: UpdateUserBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getUpdateMeUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserBody),
  });
};

export const getUpdateMeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: BodyType<UpdateUserBody> },
  TContext
> => {
  const mutationKey = ["updateMe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMe>>,
    { data: BodyType<UpdateUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMe>>
>;
export type UpdateMeMutationBody = BodyType<UpdateUserBody>;
export type UpdateMeMutationError = ErrorType<void>;

/**
 * @summary Update current user profile
 */
export const useUpdateMe = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: BodyType<UpdateUserBody> },
  TContext
> => {
  return useMutation(getUpdateMeMutationOptions(options));
};

/**
 * Claim admin role by verifying the gateway password hash
 * @summary Claim admin role
 */
export const getClaimAdminUrl = () => {
  return `/api/auth/claim-admin`;
};

export const claimAdmin = async (
  claimAdminBody: ClaimAdminBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getClaimAdminUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(claimAdminBody),
  });
};

export const getClaimAdminMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimAdmin>>,
    TError,
    { data: BodyType<ClaimAdminBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimAdmin>>,
  TError,
  { data: BodyType<ClaimAdminBody> },
  TContext
> => {
  const mutationKey = ["claimAdmin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimAdmin>>,
    { data: BodyType<ClaimAdminBody> }
  > = (props) => {
    const { data } = props ?? {};
    return claimAdmin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimAdmin>>
>;
export type ClaimAdminMutationBody = BodyType<ClaimAdminBody>;
export type ClaimAdminMutationError = ErrorType<void>;

/**
 * Claim admin role by verifying the gateway password hash
 * @summary Claim admin role
 */
export const useClaimAdmin = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimAdmin>>,
    TError,
    { data: BodyType<ClaimAdminBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof claimAdmin>>,
  TError,
  { data: BodyType<ClaimAdminBody> },
  TContext
> => {
  return useMutation(getClaimAdminMutationOptions(options));
};

export interface ListPoolsParams {
  search?: string;
  category?: string;
  status?: string;
  page?: number;
  limit?: number;
}

/**
 * @summary List all active debt relief pools
 */
export const getListPoolsUrl = (params?: ListPoolsParams) => {
  const qs = new URLSearchParams();
  if (params?.search) qs.set("search", params.search);
  if (params?.category) qs.set("category", params.category);
  if (params?.status) qs.set("status", params.status);
  if (params?.page !== undefined) qs.set("page", String(params.page));
  if (params?.limit !== undefined) qs.set("limit", String(params.limit));
  const str = qs.toString();
  return str ? `/api/pools?${str}` : `/api/pools`;
};

export const listPools = async (params?: ListPoolsParams, options?: RequestInit): Promise<PoolListResponse> => {
  return customFetch<PoolListResponse>(getListPoolsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPoolsQueryKey = (params?: ListPoolsParams) => {
  return [`/api/pools`, params] as const;
};

export const getListPoolsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPools>>,
  TError = ErrorType<unknown>,
>(options?: {
  params?: ListPoolsParams;
  query?: UseQueryOptions<Awaited<ReturnType<typeof listPools>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { params, query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPoolsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPools>>> = ({
    signal,
  }) => listPools(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPools>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPoolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPools>>
>;
export type ListPoolsQueryError = ErrorType<unknown>;

/**
 * @summary List all active debt relief pools
 */

export function useListPools<
  TData = Awaited<ReturnType<typeof listPools>>,
  TError = ErrorType<unknown>,
>(options?: {
  params?: ListPoolsParams;
  query?: UseQueryOptions<Awaited<ReturnType<typeof listPools>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPoolsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new pool (admin only)
 */
export const getCreatePoolUrl = () => {
  return `/api/pools`;
};

export const createPool = async (
  createPoolBody: CreatePoolBody,
  options?: RequestInit,
): Promise<Pool> => {
  return customFetch<Pool>(getCreatePoolUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPoolBody),
  });
};

export const getCreatePoolMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPool>>,
    TError,
    { data: BodyType<CreatePoolBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPool>>,
  TError,
  { data: BodyType<CreatePoolBody> },
  TContext
> => {
  const mutationKey = ["createPool"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPool>>,
    { data: BodyType<CreatePoolBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPool(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePoolMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPool>>
>;
export type CreatePoolMutationBody = BodyType<CreatePoolBody>;
export type CreatePoolMutationError = ErrorType<unknown>;

/**
 * @summary Create a new pool (admin only)
 */
export const useCreatePool = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPool>>,
    TError,
    { data: BodyType<CreatePoolBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPool>>,
  TError,
  { data: BodyType<CreatePoolBody> },
  TContext
> => {
  return useMutation(getCreatePoolMutationOptions(options));
};

/**
 * @summary Get a pool by ID
 */
export const getGetPoolUrl = (id: number) => {
  return `/api/pools/${id}`;
};

export const getPool = async (
  id: number,
  options?: RequestInit,
): Promise<Pool> => {
  return customFetch<Pool>(getGetPoolUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPoolQueryKey = (id: number) => {
  return [`/api/pools/${id}`] as const;
};

export const getGetPoolQueryOptions = <
  TData = Awaited<ReturnType<typeof getPool>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPool>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPoolQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPool>>> = ({
    signal,
  }) => getPool(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPool>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPoolQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPool>>
>;
export type GetPoolQueryError = ErrorType<void>;

/**
 * @summary Get a pool by ID
 */

export function useGetPool<
  TData = Awaited<ReturnType<typeof getPool>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPool>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPoolQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get aggregate pool statistics (total erased, active pools, debtors helped)
 */
export const getGetPoolStatsUrl = () => {
  return `/api/pools/stats`;
};

export const getPoolStats = async (
  options?: RequestInit,
): Promise<PoolStats> => {
  return customFetch<PoolStats>(getGetPoolStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPoolStatsQueryKey = () => {
  return [`/api/pools/stats`] as const;
};

export const getGetPoolStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPoolStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPoolStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPoolStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPoolStats>>> = ({
    signal,
  }) => getPoolStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPoolStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPoolStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPoolStats>>
>;
export type GetPoolStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get aggregate pool statistics (total erased, active pools, debtors helped)
 */

export function useGetPoolStats<
  TData = Awaited<ReturnType<typeof getPoolStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPoolStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPoolStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a Stripe checkout session for a donation
 */
export const getCreateDonationCheckoutUrl = () => {
  return `/api/donations/checkout`;
};

export const createDonationCheckout = async (
  createDonationCheckoutBody: CreateDonationCheckoutBody,
  options?: RequestInit,
): Promise<CheckoutResponse> => {
  return customFetch<CheckoutResponse>(getCreateDonationCheckoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createDonationCheckoutBody),
  });
};

export const getCreateDonationCheckoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDonationCheckout>>,
    TError,
    { data: BodyType<CreateDonationCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDonationCheckout>>,
  TError,
  { data: BodyType<CreateDonationCheckoutBody> },
  TContext
> => {
  const mutationKey = ["createDonationCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDonationCheckout>>,
    { data: BodyType<CreateDonationCheckoutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createDonationCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDonationCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDonationCheckout>>
>;
export type CreateDonationCheckoutMutationBody =
  BodyType<CreateDonationCheckoutBody>;
export type CreateDonationCheckoutMutationError = ErrorType<void>;

/**
 * @summary Create a Stripe checkout session for a donation
 */
export const useCreateDonationCheckout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDonationCheckout>>,
    TError,
    { data: BodyType<CreateDonationCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDonationCheckout>>,
  TError,
  { data: BodyType<CreateDonationCheckoutBody> },
  TContext
> => {
  return useMutation(getCreateDonationCheckoutMutationOptions(options));
};

/**
 * @summary Get authenticated donor's donation history
 */
export const getGetMyDonationsUrl = () => {
  return `/api/donations/my`;
};

export const getMyDonations = async (
  options?: RequestInit,
): Promise<Donation[]> => {
  return customFetch<Donation[]>(getGetMyDonationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyDonationsQueryKey = () => {
  return [`/api/donations/my`] as const;
};

export const getGetMyDonationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyDonations>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyDonations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyDonationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDonations>>> = ({
    signal,
  }) => getMyDonations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyDonations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyDonationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyDonations>>
>;
export type GetMyDonationsQueryError = ErrorType<void>;

/**
 * @summary Get authenticated donor's donation history
 */

export function useGetMyDonations<
  TData = Awaited<ReturnType<typeof getMyDonations>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyDonations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyDonationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get donor's real-time impact summary
 */
export const getGetMyImpactUrl = () => {
  return `/api/donations/impact`;
};

export const getMyImpact = async (
  options?: RequestInit,
): Promise<DonorImpact> => {
  return customFetch<DonorImpact>(getGetMyImpactUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyImpactQueryKey = () => {
  return [`/api/donations/impact`] as const;
};

export const getGetMyImpactQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyImpact>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyImpact>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyImpactQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyImpact>>> = ({
    signal,
  }) => getMyImpact({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyImpact>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyImpactQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyImpact>>
>;
export type GetMyImpactQueryError = ErrorType<void>;

/**
 * @summary Get donor's real-time impact summary
 */

export function useGetMyImpact<
  TData = Awaited<ReturnType<typeof getMyImpact>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyImpact>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyImpactQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download tax certificate PDF for a donation
 */
export const getGetDonationCertificateUrl = (id: number) => {
  return `/api/donations/${id}/certificate`;
};

export const getDonationCertificate = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetDonationCertificateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDonationCertificateQueryKey = (id: number) => {
  return [`/api/donations/${id}/certificate`] as const;
};

export const getGetDonationCertificateQueryOptions = <
  TData = Awaited<ReturnType<typeof getDonationCertificate>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDonationCertificate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDonationCertificateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDonationCertificate>>
  > = ({ signal }) => getDonationCertificate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDonationCertificate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDonationCertificateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDonationCertificate>>
>;
export type GetDonationCertificateQueryError = ErrorType<void>;

/**
 * @summary Download tax certificate PDF for a donation
 */

export function useGetDonationCertificate<
  TData = Awaited<ReturnType<typeof getDonationCertificate>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDonationCertificate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDonationCertificateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get authenticated debtor's submitted debts
 */
export const getGetMyDebtsUrl = () => {
  return `/api/debts`;
};

export const getMyDebts = async (options?: RequestInit): Promise<Debt[]> => {
  return customFetch<Debt[]>(getGetMyDebtsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyDebtsQueryKey = () => {
  return [`/api/debts`] as const;
};

export const getGetMyDebtsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyDebts>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyDebts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyDebtsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDebts>>> = ({
    signal,
  }) => getMyDebts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyDebts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyDebtsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyDebts>>
>;
export type GetMyDebtsQueryError = ErrorType<void>;

/**
 * @summary Get authenticated debtor's submitted debts
 */

export function useGetMyDebts<
  TData = Awaited<ReturnType<typeof getMyDebts>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyDebts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyDebtsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a debt PDF for OCR parsing and pool assignment
 */
export const getUploadDebtUrl = () => {
  return `/api/debts/upload`;
};

export const uploadDebt = async (
  uploadDebtBody: UploadDebtBody,
  options?: RequestInit,
): Promise<Debt> => {
  const formData = new FormData();
  formData.append(`file`, uploadDebtBody.file);

  return customFetch<Debt>(getUploadDebtUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadDebtMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadDebt>>,
    TError,
    { data: BodyType<UploadDebtBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadDebt>>,
  TError,
  { data: BodyType<UploadDebtBody> },
  TContext
> => {
  const mutationKey = ["uploadDebt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadDebt>>,
    { data: BodyType<UploadDebtBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadDebt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadDebtMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadDebt>>
>;
export type UploadDebtMutationBody = BodyType<UploadDebtBody>;
export type UploadDebtMutationError = ErrorType<void>;

/**
 * @summary Upload a debt PDF for OCR parsing and pool assignment
 */
export const useUploadDebt = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadDebt>>,
    TError,
    { data: BodyType<UploadDebtBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadDebt>>,
  TError,
  { data: BodyType<UploadDebtBody> },
  TContext
> => {
  return useMutation(getUploadDebtMutationOptions(options));
};

/**
 * @summary Download forgiveness letter PDF for a cleared debt
 */
export const getGetDebtLetterUrl = (id: number) => {
  return `/api/debts/${id}/letter`;
};

export const getDebtLetter = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetDebtLetterUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDebtLetterQueryKey = (id: number) => {
  return [`/api/debts/${id}/letter`] as const;
};

export const getGetDebtLetterQueryOptions = <
  TData = Awaited<ReturnType<typeof getDebtLetter>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDebtLetter>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDebtLetterQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDebtLetter>>> = ({
    signal,
  }) => getDebtLetter(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDebtLetter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDebtLetterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDebtLetter>>
>;
export type GetDebtLetterQueryError = ErrorType<void>;

/**
 * @summary Download forgiveness letter PDF for a cleared debt
 */

export function useGetDebtLetter<
  TData = Awaited<ReturnType<typeof getDebtLetter>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDebtLetter>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDebtLetterQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get admin dashboard overview stats
 */
export const getGetAdminStatsUrl = () => {
  return `/api/admin/stats`;
};

export const getAdminStats = async (
  options?: RequestInit,
): Promise<AdminStats> => {
  return customFetch<AdminStats>(getGetAdminStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminStatsQueryKey = () => {
  return [`/api/admin/stats`] as const;
};

export const getGetAdminStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminStats>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStats>>> = ({
    signal,
  }) => getAdminStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminStats>>
>;
export type GetAdminStatsQueryError = ErrorType<void>;

/**
 * @summary Get admin dashboard overview stats
 */

export function useGetAdminStats<
  TData = Awaited<ReturnType<typeof getAdminStats>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all pools with full details (admin)
 */
export const getAdminListPoolsUrl = () => {
  return `/api/admin/pools`;
};

export const adminListPools = async (
  options?: RequestInit,
): Promise<Pool[]> => {
  return customFetch<Pool[]>(getAdminListPoolsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListPoolsQueryKey = () => {
  return [`/api/admin/pools`] as const;
};

export const getAdminListPoolsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListPools>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPools>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListPoolsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListPools>>> = ({
    signal,
  }) => adminListPools({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListPools>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListPoolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListPools>>
>;
export type AdminListPoolsQueryError = ErrorType<unknown>;

/**
 * @summary List all pools with full details (admin)
 */

export function useAdminListPools<
  TData = Awaited<ReturnType<typeof adminListPools>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPools>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListPoolsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all debt submissions (admin)
 */
export const getAdminListDebtsUrl = () => {
  return `/api/admin/debts`;
};

export const adminListDebts = async (
  options?: RequestInit,
): Promise<Debt[]> => {
  return customFetch<Debt[]>(getAdminListDebtsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListDebtsQueryKey = () => {
  return [`/api/admin/debts`] as const;
};

export const getAdminListDebtsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDebts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListDebts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListDebtsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListDebts>>> = ({
    signal,
  }) => adminListDebts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDebts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListDebtsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDebts>>
>;
export type AdminListDebtsQueryError = ErrorType<unknown>;

/**
 * @summary List all debt submissions (admin)
 */

export function useAdminListDebts<
  TData = Awaited<ReturnType<typeof adminListDebts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListDebts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListDebtsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all donations (admin)
 */
export const getAdminListDonationsUrl = () => {
  return `/api/admin/donations`;
};

export const adminListDonations = async (
  options?: RequestInit,
): Promise<Donation[]> => {
  return customFetch<Donation[]>(getAdminListDonationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListDonationsQueryKey = () => {
  return [`/api/admin/donations`] as const;
};

export const getAdminListDonationsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListDonations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListDonations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListDonationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListDonations>>
  > = ({ signal }) => adminListDonations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListDonations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListDonationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListDonations>>
>;
export type AdminListDonationsQueryError = ErrorType<unknown>;

/**
 * @summary List all donations (admin)
 */

export function useAdminListDonations<
  TData = Awaited<ReturnType<typeof adminListDonations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListDonations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListDonationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all payout records (admin)
 */
export const getAdminListPayoutsUrl = () => {
  return `/api/admin/payouts`;
};

export const adminListPayouts = async (
  options?: RequestInit,
): Promise<Payout[]> => {
  return customFetch<Payout[]>(getAdminListPayoutsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListPayoutsQueryKey = () => {
  return [`/api/admin/payouts`] as const;
};

export const getAdminListPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListPayouts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPayouts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListPayoutsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListPayouts>>
  > = ({ signal }) => adminListPayouts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListPayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListPayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListPayouts>>
>;
export type AdminListPayoutsQueryError = ErrorType<unknown>;

/**
 * @summary List all payout records (admin)
 */

export function useAdminListPayouts<
  TData = Awaited<ReturnType<typeof adminListPayouts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPayouts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListPayoutsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get top donors leaderboard (admin)
 */
export const getAdminGetLeaderboardUrl = () => {
  return `/api/admin/leaderboard`;
};

export const adminGetLeaderboard = async (
  options?: RequestInit,
): Promise<LeaderboardEntry[]> => {
  return customFetch<LeaderboardEntry[]>(getAdminGetLeaderboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetLeaderboardQueryKey = () => {
  return [`/api/admin/leaderboard`] as const;
};

export const getAdminGetLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLeaderboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLeaderboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetLeaderboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetLeaderboard>>
  > = ({ signal }) => adminGetLeaderboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLeaderboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetLeaderboard>>
>;
export type AdminGetLeaderboardQueryError = ErrorType<unknown>;

/**
 * @summary Get top donors leaderboard (admin)
 */

export function useAdminGetLeaderboard<
  TData = Awaited<ReturnType<typeof adminGetLeaderboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLeaderboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetLeaderboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually approve a pending payout
 */
export const getAdminApprovePayoutUrl = (id: number) => {
  return `/api/admin/payouts/${id}/approve`;
};

export const adminApprovePayout = async (
  id: number,
  options?: RequestInit,
): Promise<Payout> => {
  return customFetch<Payout>(getAdminApprovePayoutUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminApprovePayoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminApprovePayout>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminApprovePayout>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminApprovePayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminApprovePayout>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminApprovePayout(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminApprovePayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminApprovePayout>>
>;

export type AdminApprovePayoutMutationError = ErrorType<void>;

/**
 * @summary Manually approve a pending payout
 */
export const useAdminApprovePayout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminApprovePayout>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminApprovePayout>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminApprovePayoutMutationOptions(options));
};

/**
 * @summary Block (fail) a pending payout
 */
export const getAdminBlockPayoutUrl = (id: number) => {
  return `/api/admin/payouts/${id}/block`;
};

export const adminBlockPayout = async (
  id: number,
  options?: RequestInit,
): Promise<Payout> => {
  return customFetch<Payout>(getAdminBlockPayoutUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminBlockPayoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBlockPayout>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminBlockPayout>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminBlockPayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminBlockPayout>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminBlockPayout(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBlockPayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminBlockPayout>>
>;

export type AdminBlockPayoutMutationError = ErrorType<void>;

/**
 * @summary Block (fail) a pending payout
 */
export const useAdminBlockPayout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBlockPayout>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminBlockPayout>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminBlockPayoutMutationOptions(options));
};

/**
 * @summary Get admin audit log entries
 */
export const getAdminListAuditLogsUrl = (params?: AdminListAuditLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/audit-logs?${stringifiedParams}`
    : `/api/admin/audit-logs`;
};

export const adminListAuditLogs = async (
  params?: AdminListAuditLogsParams,
  options?: RequestInit,
): Promise<AuditLog[]> => {
  return customFetch<AuditLog[]>(getAdminListAuditLogsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListAuditLogsQueryKey = (
  params?: AdminListAuditLogsParams,
) => {
  return [`/api/admin/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getAdminListAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListAuditLogs>>,
  TError = ErrorType<void>,
>(
  params?: AdminListAuditLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAuditLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListAuditLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListAuditLogs>>
  > = ({ signal }) => adminListAuditLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListAuditLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListAuditLogs>>
>;
export type AdminListAuditLogsQueryError = ErrorType<void>;

/**
 * @summary Get admin audit log entries
 */

export function useAdminListAuditLogs<
  TData = Awaited<ReturnType<typeof adminListAuditLogs>>,
  TError = ErrorType<void>,
>(
  params?: AdminListAuditLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAuditLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListAuditLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get public top donors leaderboard
 */
export const getGetLeaderboardUrl = () => {
  return `/api/leaderboard`;
};

export const getLeaderboard = async (
  options?: RequestInit,
): Promise<LeaderboardEntry[]> => {
  return customFetch<LeaderboardEntry[]>(getGetLeaderboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLeaderboardQueryKey = () => {
  return [`/api/leaderboard`] as const;
};

export const getGetLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLeaderboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeaderboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeaderboard>>> = ({
    signal,
  }) => getLeaderboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeaderboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeaderboard>>
>;
export type GetLeaderboardQueryError = ErrorType<unknown>;

/**
 * @summary Get public top donors leaderboard
 */

export function useGetLeaderboard<
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLeaderboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeaderboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get authenticated donor's badge tier and SVG
 */
export const getGetMyBadgesUrl = () => {
  return `/api/badges/my`;
};

export const getMyBadges = async (
  options?: RequestInit,
): Promise<BadgeInfo> => {
  return customFetch<BadgeInfo>(getGetMyBadgesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyBadgesQueryKey = () => {
  return [`/api/badges/my`] as const;
};

export const getGetMyBadgesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyBadges>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyBadges>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyBadgesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBadges>>> = ({
    signal,
  }) => getMyBadges({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyBadges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyBadgesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyBadges>>
>;
export type GetMyBadgesQueryError = ErrorType<void>;

/**
 * @summary Get authenticated donor's badge tier and SVG
 */

export function useGetMyBadges<
  TData = Awaited<ReturnType<typeof getMyBadges>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyBadges>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyBadgesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
